let menu = JSON.parse(sessionStorage.getItem("menufarm"));
let role = sessionStorage.getItem("role");
let system_role = sessionStorage.getItem("system_role");

let arrsubMenu = [];
let mergeMenu = [];
let settingmenu;

if (menu) {
  menu.forEach(element => {
    arrsubMenu = [];
    element.plot.forEach(elementPlot => {
      arrsubMenu.push({
        title: elementPlot.name,
        routerLink: `preload-plot-detail`,
        id: elementPlot._id,
        param: {
          farmId: element._id,
          plotId: elementPlot._id,
          cropId: elementPlot.crop ? elementPlot.crop._id : null,
          zoneId: elementPlot.zone ? elementPlot.zone._id : null
        }
      })
    });
    mergeMenu.push({
      title: element.name,
      id: element._id,
      icon: '',
      items: arrsubMenu
    })
  });
}

mergeMenu.push(
  {
    title: 'จัดการฟาร์ม',
    routerLink: 'manage-farm'
  }
)

console.log("menu... ");
console.log("role: ",role);
console.log("system_role:", system_role);

if(role == 'admin' || role == 'farm_manager'){
  settingmenu = {
    title: 'ตั้งค่าระบบ',
    tags: 'theme settings how it works',
    icon: 'fal fa-box-check',
    items: [
      {
        title: 'ตั้งค่าผลผลิต',
        tags: 'theme settings how it works',
        routerLink: 'manage-yield'
      },
      {
        title: 'จัดการผู้ใช้งาน',
        tags: 'theme settings how it works',
        routerLink: 'manage-user'
      },
      {
        title: 'จัดการอุปกรณ์',
        tags: 'theme settings how it works',
        routerLink: 'manage-thing'
      },
    ]
  }
}else{
  settingmenu = {
    title: 'ตั้งค่าระบบ',
    tags: 'theme settings how it works',
    icon: 'fal fa-box-check',
    items: [
      {
        title: 'ตั้งค่าผลผลิต',
        tags: 'theme settings how it works',
        routerLink: 'manage-yield'
      }
    ]
  }
}

export const NavigationItems = [
  {
    title: 'Dashboard',
    tags: 'application intel',
    icon: 'ni ni-home',
    routerLink: '#/dashboard'
  },
  {
    title: 'Farm Dashboard',
    tags: 'application intel',
    icon: 'farm',
    items: mergeMenu
  },
  // {
  //   title: 'พยากรณ์อากาศ',
  //   tags: 'application intel',
  //   icon: 'satellite',
  //   routerLink: 'weather-forecast'
  // },
  {
    title: 'Report',
    tags: 'application intel',
    icon: 'report',
    routerLink: 'report'
  },
  settingmenu ? settingmenu : {}
];
